import type { Camera, Scene, WebGLRenderer } from 'three'

export type PlannerR3FState = {
  gl: WebGLRenderer
  scene: Scene
  camera: Camera
  invalidate: () => void
  advance?: (timestamp: number, runGlobalEffects?: boolean) => void
}

let plannerR3F: PlannerR3FState | null = null

type R3FWindow = Window & { r3f?: { invalidate?: () => void } }

export function registerPlannerR3F(state: PlannerR3FState) {
  plannerR3F = state
  if (typeof window !== 'undefined') {
    ;(window as R3FWindow).r3f = { invalidate: state.invalidate }
  }
}

export function unregisterPlannerR3F(state?: PlannerR3FState | null) {
  if (state && plannerR3F && state.gl !== plannerR3F.gl) return
  plannerR3F = null
  if (typeof window !== 'undefined') {
    delete (window as R3FWindow).r3f
  }
}

export function getPlannerR3F(): PlannerR3FState | null {
  return plannerR3F
}
